<template>

<app-page v-if="is.loaded" :title="page.forgot_title" :description="page.forgot_description">

	<app-inner :row="true" :condensed="true">

		<app-text>

			<app-message :error="true" v-if="is.errored">

				{{ page.forgot_message_error }}

			</app-message>

			<app-message :success="true" v-if="is.saved">

				{{ page.forgot_message_success }}

			</app-message>

			<app-group>

				<app-input-text v-model="inputs.email" :errored="errored.email" :placeholder="page.forgot_email_placeholder" />

			</app-group>

            <app-group :row="true" :center="true">

                <app-button theme="blue" :loading="is.submitting" :text="page.forgot_button_save" v-on:click="onForgotClick" />

            </app-group>

		</app-text>

	</app-inner>

</app-page>

</template>

<script>

import mixinPage from '@/mixin/page.js'
import mixinForm from '@/mixin/form.js'

export default {

	mixins: [mixinPage, mixinForm],

	data: function() {

		return {
            stayAfterSave: true,
			inputs: {
				email: ''
			},
			rules: {
				email: {
					required: true
				}
			}
		}

	},
	
	methods: {

		onForgotClick: function() {

			this.save('login/forgot', {
				email: this.inputs.email
			})

		}

	}

}

</script>